import { Download, Upload, Trash2 } from "lucide-react";
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { useNavigateToBackupReset } from "@/hooks/use-navigate-to-backup-reset";

interface BusinessLite {
  id: string;
  name: string;
}

/**
 * Three dropdown items (Download backup / Restore / Reset) for a per-row
 * business action menu. Caller is expected to wrap them in a `DropdownMenuContent`
 * and to gate visibility on `canManageBusinessData` themselves.
 */
export function BusinessDataActionItems({
  business,
}: {
  business: BusinessLite;
}) {
  const go = useNavigateToBackupReset();
  return (
    <>
      <DropdownMenuLabel className="typo-label text-[color:var(--color-text-lo)]">
        Backup & Reset
      </DropdownMenuLabel>
      <DropdownMenuItem onClick={() => void go(business.id, "download")}>
        <Download className="mr-2 h-3.5 w-3.5" aria-hidden />
        Download backup
      </DropdownMenuItem>
      <DropdownMenuItem onClick={() => void go(business.id, "restore")}>
        <Upload className="mr-2 h-3.5 w-3.5" aria-hidden />
        Restore from backup
      </DropdownMenuItem>
      <DropdownMenuItem
        className="text-destructive focus:text-destructive"
        onClick={() => void go(business.id, "reset")}
      >
        <Trash2 className="mr-2 h-3.5 w-3.5" aria-hidden />
        Reset data
      </DropdownMenuItem>
      <DropdownMenuSeparator />
    </>
  );
}
